import React from 'react';
import CategoryAndFolderSelector from './CategoryAndFolderSelector';
import { getQuestionUrl } from '../../utilities/urlHelper';

const MoveQuestionModal = (props) => {
    const { question } = props;

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            closeModal();
        }
    };

    const closeModal = () => {
        props.closeModal();
    };

    return (
        <div className="react-modal open move-question-modal" onMouseDown={onClickModal}>
            <div className="modal-content">
                <h2>Move question</h2>
                <div className="mt2 mb2 flex">
                    <img className="flex-none mr1" height="22" src="/img/icons/file-icon-question.png" alt="" />
                    <div className="flex-auto">
                        <span className="h4">{question.title}</span>
                    </div>
                </div>
                <form action={getQuestionUrl(question.id)} method="POST">
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <input name="_method" type="hidden" value="put" />
                    <input name="title" type="hidden" value={question.title} />
                    <div className="mt2 mb2">
                        <CategoryAndFolderSelector
                            initialCategoryId={question.category_id}
                            initialFolderId={question.folder_id}
                        />
                    </div>
                    <div className="right-align">
                        <span className="react-modal-close btn-secondary mr1" onClick={closeModal}>Close</span>
                        <input type="submit" className="btn btn-primary" value="Move question" />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default MoveQuestionModal;
